import { render, staticRenderFns } from "./CurrencyAmount.vue?vue&type=template&id=71b8e35e&scoped=true&"
import script from "./CurrencyAmount.vue?vue&type=script&lang=js&"
export * from "./CurrencyAmount.vue?vue&type=script&lang=js&"
import style0 from "./CurrencyAmount.vue?vue&type=style&index=0&id=71b8e35e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71b8e35e",
  null
  
)

export default component.exports